module.exports = __webpack_public_path__ + "static/media/0331_LES_ENSEIGNES_PORTIONS_HERSE.aa62001a.webp";